import moment from "moment";

const ONE_DAY = 86400000;
const ONE_MINUTE = 60000;

export const getTimeDifference = (startTime, endTime) => {
  let ms = moment(endTime).diff(moment(startTime));
  let d = moment.duration(ms);
  return d.hours() + "H : " + d.minutes() + "M : " + d.seconds() + "S";
};

export const getTimeRemaining = (endtime) => {
  const total = Date.parse(new Date(endtime)) - Date.parse(new Date());
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return {
    total,
    days,
    hours,
    minutes,
    seconds,
  };
};

export const getTimeRemainingInNumbers = (endtime) => {
  const total = Date.parse(new Date(endtime)) - Date.parse(new Date());

  return total;
};

export function getAge(time) {
  if (!time) return;
  try {
    const currentDate = new Date(),
      currentYear = currentDate.getFullYear(),
      birthYear = new Date(time).getFullYear();
    return currentYear - birthYear;
  } catch (error) {
    return time;
  }
}

export function dateFormat(date) {
  return new Date(date).toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function timeFormat(date) {
  return new Date(date).toLocaleString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export function datetimeFormat(date) {
  return new Date(date).toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export function timeDiffInMin(d1, d2) {
  let difference = new Date(d1).getTime() - new Date(d2).getTime(); // This will give difference in milliseconds
  return difference / 60000;
  // var diffMs = new Date(d1) - new Date(d2);
  // return Math.round(((diffMs % 86400000) % 3600000) / 60000);
}

export function timeDiffInMinCallLogs(d1, d2) {
  const callLogsTimeDiff = new Date(d1).getTime() - new Date(d2).getTime();
  const callLogsTimeDiffInSec = callLogsTimeDiff / 1000
  return callLogsTimeDiffInSec
}

export function userFullName(userData) {
  let fullName = "";
  userData && userData.firstName
    ? userData.lastName
      ? (fullName = `${userData.firstName} ${userData.lastName}`)
      : (fullName = `${userData.firstName}`)
    : (fullName = "");
  return fullName;
}



export function reccuringSchedule(value) {
  let newScheduleEvents = {};
  let sod = new Date();
  sod.setHours(0, 0, 0, 0);
  let eod = new Date();
  eod.setHours(23, 59, 59, 999);

  let _starts = value?.startTimeUTC;
  let endDuration = value?.duration * ONE_MINUTE;
  if (value?.isRecurring) {
    for (let i = 1; i <= Number(value?.recurring?.until); i++) {
      let item = { ...value };
      if (value.recurring.frequence !== 'weekly') {
        let _ends = _starts + endDuration;
        if ((sod <= _starts && _starts <= eod) || (sod <= _ends && _ends <= eod)) {
          item["startTimeUTC"] = _starts;
          item["endTimeUTC"] = _ends;
          // if (_ends > new Date().valueOf()) {
          newScheduleEvents = { ...item };
          // }
          break;
        }
      }
      if (value?.recurring?.frequence === 'daily') {
        _starts += (Number(value.recurring.interval) * ONE_DAY);
      } else if (value.recurring.frequence === 'monthly') {
        let dt = new Date(value.startTimeUTC);
        dt.setMonth(dt.getMonth() + Number(value.recurring.interval) * i);
        _starts = new Date(dt.toISOString()).getTime();
      } else if (value.recurring.frequence === 'weekly') {
        let frq = value.recurring.weekFrequency;
        for (let j in frq) {
          let _item = { ...item };
          let _ends = _starts + endDuration;
          if ((sod <= _starts && _starts <= eod) || (sod <= _ends && _ends <= eod)) {
            _item["startTimeUTC"] = _starts;
            _item["endTimeUTC"] = _ends;
            // if (_ends > new Date().valueOf()) {
            newScheduleEvents = { ..._item };
            // }
            break;
          }
          let n = Number(j) + 1;
          if (frq[n]) {
            _starts = startOfWeek(new Date(_starts)).getTime() + (frq[n] * ONE_DAY);
          }
        }
        _starts = value.startTimeUTC + (i * Number(value.recurring.interval) * 7 * ONE_DAY);
      }
    }
    return newScheduleEvents;
  } else {
    return value
  }
}

const startOfWeek = (date) => {
  let diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 0);
  return new Date(date.setDate(diff));
}